import axiosPrimitive, { AxiosError } from "axios"
import { toast } from "sonner"

import { authService } from "./auth-service"

/**
 * Axios instance configured with default settings for esign API.
 *
 * - Request interceptor: automatically attaches Bearer token from authService
 * - Response interceptor: handles 401 (redirect to login), 500 (toast error)
 */
export const axios = axiosPrimitive.create({
  baseURL: process.env.NEXT_PUBLIC_BASE_URL_API,
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json",
    "x-app-type": "esign",
  },
})

axios.interceptors.request.use(
  (config) => {
    const token = authService.getToken()

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

axios.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    const requestUrl = error.config?.url ?? ""
    const isAuthEndpoint =
      requestUrl.includes("/auth/login") ||
      requestUrl.includes("/auth/forgot-password")

    if (error.code === "ERR_NETWORK") {
      toast.error("Network error. Please check your connection.")
    } else if (error.response?.status === 401 && !isAuthEndpoint) {
      authService.clearTokens()
      if (typeof window !== "undefined") {
        window.location.href = "/auth/login"
      }
    } else if (error.response?.status === 500) {
      toast.error("Internal server error. Please try again later.")
    }

    return Promise.reject(error)
  }
)
